import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function CheckboxFieldAdapter({ input, label }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const size = useMemo(() => (isDesktop ? 'medium' : 'small'), [isDesktop]);

  const onChange = (event) => {
    input.onChange(event.target.checked);
  };

  // `input.checked` lo expone react-final-form solo cuando el Field declara type="checkbox";
  // si no, el booleano vive en `input.value`. Soportamos ambos para evitar el bug de "no se marca".
  const checked = Boolean(input.checked ?? input.value);

  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} size={size} />}
      label={label}
    />
  );
}

CheckboxFieldAdapter.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired
};

export default CheckboxFieldAdapter;
